import { useDraggable } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import T from 'prop-types';

import { isFreeTextDocument, isUploadedDocument } from 'shared/domains/documents';

import {
  BadgeCell,
  ContextMenuCell,
  StatusCell,
  TitleCell,
  DateCell,
  CreatedByCell,
} from './TableCells';
import { StyledTableRow } from './styled';

const getEntryIcon = ({ isFreeText, isUploaded }) => {
  if (isFreeText) {
    return <Falcon icon="file-edit" />;
  }

  if (isUploaded) {
    return <Falcon icon="file-upload" />;
  }

  return <Falcon icon="file-alt" />;
};

function DocumentTableRow(props) {
  const {
    id,
    type,
    documentType,
    name,
    date,
    lastSignRequest,
    onDuplicate,
    onRename,
    onMove,
    onDelete,
    onEditAccess,
    user,
    ...restProps
  } = props;

  const isFreeText = isFreeTextDocument({ type: documentType });
  const isUploaded = isUploadedDocument({ type: documentType });

  const icon = getEntryIcon({ isFreeText, isUploaded });
  const editUrl = `/document/${id}`;

  const { draggableProps, isDragging } = useDraggable(`${type}:${id}`);

  return (
    <StyledTableRow $isDraggable $isDragging={isDragging} {...draggableProps} {...restProps}>
      <BadgeCell appearance="primary">{icon}</BadgeCell>
      <TitleCell title={name} href={editUrl} />
      <DateCell headers="filesystemtable-updatedAt" date={date} />
      <CreatedByCell user={user} />
      <StatusCell align="left" status={lastSignRequest?.status} />

      <ContextMenuCell
        id={id}
        editUrl={editUrl}
        onDuplicate={onDuplicate}
        onRename={onRename}
        onMove={onMove}
        onDelete={onDelete}
        onEditAccess={onEditAccess}
      />
    </StyledTableRow>
  );
}

DocumentTableRow.displayName = 'DocumentTableRow';

DocumentTableRow.propTypes = {
  id: T.string.isRequired,
  type: T.string.isRequired,
  documentType: T.string.isRequired,
  name: T.string.isRequired,
  date: T.string.isRequired,
  lastSignRequest: T.shape({
    status: T.string,
  }),
  onDuplicate: T.func.isRequired,
  onRename: T.func.isRequired,
  onMove: T.func.isRequired,
  onDelete: T.func.isRequired,
  onEditAccess: T.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  user: T.object,
};

DocumentTableRow.defaultProps = {
  lastSignRequest: undefined,
  user: undefined,
};

export default DocumentTableRow;
